import { Input as AntInput } from 'antd';
import { GroupProps } from 'antd/lib/input/Group';
import React from 'react';

const { Group: AntInputGroup } = AntInput;

export interface IInputGroupProps extends GroupProps {}

/**
 * Input Group component
 */
export const Group: React.FC<IInputGroupProps> = (props) => (
  <AntInputGroup {...props} />
);
